module.exports = __webpack_public_path__ + "static/2_3_game-tree-4_DA-f66d818c92280b321126e6ffe55163d1.svg";